import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CreateSpecialFundInfo {
  pId: string;
  collectionName: string;
  parentSpecialCollectionName: string;
  netSuiteCreditAccount: string;
  parentNetSuiteCreditAccount: string;
  debitAccount: string;
  parentDebitAccount: string;
  netSuiteCreditFundNumber: string;
  parentNetSuiteCreditFundNumber: string;
  debitFundNumber: string;
  parentNetSuiteDebitFundNumber: string;
  netSuiteCreditRestrictionNumber: string;
  parentNetSuiteCreditRestrictionNumber: string;
  debitRestrictionNumber: string;
  parentNetSuiteDebitRestrictionNumber: string;
  netSuiteCreditProgramCode: string;
  parentNetSuiteCreditProgramCode: string;
  netSuiteDebitProgramCode: string;
  parentNetSuiteDeditProgramCode: string;
  netSuiteCreditDepartment: string;
  parentNetSuiteCreditDepartment: string;
  netSuiteDebitAccount: string;
  parentNetSuiteDebitAccount: string;
  netSuiteDebitDepartment: string;
  parentNetSuiteDebitDepartment: string;
  creditFundNo: string;
  parentCreditFundNo: string;
  programCode: string;
  parentProgramCode: string;
  requestorComments: string;
  parentRequestorComments: string;
  page: number;
  rowsPerPage: number;
  searchCollectionName: string;
  id: number;
  status: string;
  projectNumber: string;
  parentProjectNumber: string;
  approvalRejectionComments: string;
  version: number;
  creditLocationRequired: string;
  parentCreditLocationRequired: string;
  debitLocationRequired: string;
  parentDebitLocationRequired: string;
  specialCollectionId: string;
  specialCollectionApprovalRequest: {
    id: number;
  };
  freeze: boolean;
  parentFreeze: boolean;
  isFreeze: string;
  isReactivate: boolean;
  openReactive: boolean;
  action: string;
  checkCredit: boolean;
  checkDebit: boolean;
  parentCheckCredit: boolean;
  parentCheckDebit: boolean;
  approvalHistory: any[];
  openMoreInfo: boolean;
  childTableLength: number;
  parentStatus:string;
  statusArray:string[];
  inprogressFlag:boolean
}

const initialState: CreateSpecialFundInfo = {
  pId: "",
  collectionName: "",
  parentSpecialCollectionName: "",
  netSuiteCreditAccount: "",
  parentNetSuiteCreditAccount: "",
  debitAccount: "",
  parentDebitAccount: "",
  netSuiteCreditFundNumber: "",
  parentNetSuiteCreditFundNumber: "",
  debitFundNumber: "",
  parentNetSuiteDebitFundNumber: "",
  netSuiteCreditRestrictionNumber: "",
  parentNetSuiteCreditRestrictionNumber: "",
  debitRestrictionNumber: "",
  parentNetSuiteDebitRestrictionNumber: "",
  netSuiteCreditProgramCode: "",
  parentNetSuiteCreditProgramCode: "",
  netSuiteDebitProgramCode: "",
  parentNetSuiteDeditProgramCode: "",
  netSuiteCreditDepartment: "",
  parentNetSuiteCreditDepartment: "",
  netSuiteDebitAccount: "",
  parentNetSuiteDebitAccount: "",
  netSuiteDebitDepartment: "",
  parentNetSuiteDebitDepartment: "",
  creditFundNo: "",
  parentCreditFundNo: "",
  programCode: "",
  parentProgramCode: "",
  requestorComments: "",
  parentRequestorComments: "",
  page: 0,
  rowsPerPage: 5,
  searchCollectionName: "",
  id: 0,
  status: "",
  projectNumber: "",
  parentProjectNumber: "",
  approvalRejectionComments: "",
  version: 0,
  creditLocationRequired: "",
  parentCreditLocationRequired: "",
  debitLocationRequired: "",
  parentDebitLocationRequired: "",
  specialCollectionId: "",

  specialCollectionApprovalRequest: {
    id: 0,
  },
  freeze: false,
  isFreeze: "",
  parentFreeze: false,
  isReactivate: true,
  openReactive: false,
  action: "",
  checkCredit: false,
  checkDebit: false,
  parentCheckCredit: false,
  parentCheckDebit: false,
  approvalHistory: [],
  openMoreInfo: false,
  childTableLength: 0,
  parentStatus:"",
  statusArray:["Active","Opened","Suspended"],
  inprogressFlag:false
};

const CreateSpecialFundSlice = createSlice({
  name: "specialFund",
  initialState,
  reducers: {
    setCreateSpecialFund: (
      state,
      action: PayloadAction<Partial<CreateSpecialFundInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeCreateSpecialFund: () => initialState,
  },
});

export const { setCreateSpecialFund, removeCreateSpecialFund } =
  CreateSpecialFundSlice.actions;
export default CreateSpecialFundSlice.reducer;
